/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_alumniSurveyEmploymentInformationAnswer = {
    employer_name?: string;
    job_title?: string;
    sector_type?: api_alumniSurveyEmploymentInformationAnswer.sector_type;
    seniority_level_id?: number;
};
export namespace api_alumniSurveyEmploymentInformationAnswer {
    export enum sector_type {
        PUBLIC = 'public',
        PRIVATE = 'private',
        NON_PROFIT = 'non_profit',
        INTERNATIONAL_ORGANISATION = 'international_organisation',
        ACADEMIC_RESEARCH = 'academic_research',
    }
}

